import angular from 'angular';

import ManageUserListCtrl from '../dashboard/manage/users/ManageUserListCtrl';
import EditUserProfileCtrl from '../dashboard/manage/users/EditUserProfileCtrl';
import { accessLevels } from '../constants';
import UserWagesHistoryCtrl from '../dashboard/manage/users/UserWagesHistoryCtrl';

import { STATE_DEFINITION_COMMON } from './constants';

const usersModule = angular.module('sling.users', []);

usersModule.config(($stateProvider) => {
  $stateProvider.state('users', {
    url: '/users',
    template: `
      <blocks-navigation></blocks-navigation>
      <ng-include src="ctrl.listUrl"></ng-include>
    `,
    controller: ManageUserListCtrl,
    controllerAs: 'ctrl',
    data: {
      title: 'Employees',
      access: accessLevels.user,
    },
    resolve: {
      personaCollection(PersonaCollection) {
        return PersonaCollection.loadData();
      },
    },
  });

  $stateProvider.state('users.profile', {
    ...STATE_DEFINITION_COMMON['users.profile'],
    views: {
      '@': {
        template: `
          <blocks-navigation></blocks-navigation>
          <ng-include src="ctrl.editUrl"></ng-include>
        `,
        controller: EditUserProfileCtrl,
        controllerAs: 'ctrl',
      },
    },
  });

  $stateProvider.state('users.profile.wages-history', {
    url: '/wages-history',
    resolve: {
      user(personaCollection, PersonaCollection, $transition$) {
        'ngInject';

        return PersonaCollection.personasDict[$transition$.params().userId];
      },
    },
    views: {
      '@': {
        template: `
          <blocks-navigation></blocks-navigation>
          <ng-include src="ctrl.wagesHistoryUrl"></ng-include>
        `,
        controller: UserWagesHistoryCtrl,
        controllerAs: 'ctrl',
      },
    },
  });

  $stateProvider.state('users.profile.unavailability-history', {
    url: '/unavailability-history',
    views: {
      '@': {
        template: '<unavailability-history-screen></unavailability-history-screen>',
      },
    },
  });
});

usersModule.run((Authentication, $transitions) => {
  $transitions.onEnter({ to: 'users' }, (transition) => {
    if (Authentication.user.isManager) {
      return transition.router.stateService.target(
        'dashboard.manage.users.list',
        transition.params()
      );
    }
  });

  $transitions.onEnter({ to: 'users.profile' }, (transition) => {
    if (Authentication.user.isManager) {
      return transition.router.stateService.target(
        'dashboard.manage.users.profile',
        transition.params()
      );
    }
  });
});

usersModule.run(($transitions, Authentication, PersonaCollection) => {
  $transitions.onEnter(
    {
      to: 'users.profile.wages-history',
    },
    (transition) => {
      const userId = transition.params('to').userId;
      const user = PersonaCollection.personasDict[userId];
      const canSeeHistoricalWages = user.isMe && Authentication.user.canSeeOwnWage;

      if (!canSeeHistoricalWages) {
        return transition.router.stateService.target('users.profile', { userId, tab: 'profile' });
      }
    }
  );
});

usersModule.factory('extendUserModel', (sdk) => sdk('model-extensions/extendUserModel'));

export default usersModule.name;
